import { CREATE_TRADE_PATH } from "common/constants";
import { useLocation } from "react-use";
import { useCallback } from "react";
import { matchPath } from "react-router-dom";
import {
  HelperTooltipWithTranslations,
  LanguageNameSpaces,
  OnlyHelperTooltipProps,
} from "@shared/types";
import { OrderTypes } from "@shared/features/trades/common/types";
import {
  ENTRIES_HELPER_TOOLTIP,
  STOP_HELPER_TOOLTIP,
  TAKE_PROFITS_HELPER_TOOLTIP,
  TRAILING_CREATE_TRADE_HELPER_TOOLTIP,
} from "@shared/common/Tooltips/constants";

const tooltipFields: Record<
  string,
  Record<
    string,
    HelperTooltipWithTranslations<LanguageNameSpaces.COMMON> | undefined
  >
> = Object.freeze({
  [CREATE_TRADE_PATH]: {
    Trailing: TRAILING_CREATE_TRADE_HELPER_TOOLTIP,
    [OrderTypes.ENTRY]: ENTRIES_HELPER_TOOLTIP,
    [OrderTypes.TAKE_PROFIT]: TAKE_PROFITS_HELPER_TOOLTIP,
    [OrderTypes.STOP]: STOP_HELPER_TOOLTIP,
  },
});

export const useGetTooltipConfigForField = () => {
  const location = useLocation();
  const currentPath = location.pathname || "";
  const foundPath = Object.keys(tooltipFields).find((path) =>
    matchPath(currentPath, {
      path,
      exact: false,
      strict: false,
    })
  );

  const getHelperTooltipProps = useCallback(
    (fieldName: string) => {
      if (!foundPath) return null;

      return tooltipFields?.[foundPath]?.[fieldName];
    },
    [currentPath]
  );

  return { getHelperTooltipProps };
};
